import { UserPermissions } from '@centecomm/portal-service';
import React from 'react';
import { LoadingContent } from 'Shared/PageElements';
import useComplianceHubEnabled from 'utils/Hooks/LaunchDarkly/useComplianceHubEnabled';

import { FeatureConfiguration } from '../../Core/Types/FeatureConfiguration';
import ComplianceHubNavigationIcon from '../../Icons/NavigationItem/ComplianceHub';

const LazyComplianceHubPage = React.lazy(() => import('./Pages/ComplianceHubPage'));
const isComplianceHubEnabled = () => useComplianceHubEnabled();

const complianceHubConfiguration: FeatureConfiguration = {
    name: 'Compliance Hub',
    navigationItem: {
        route: {
            text: 'common:sidebar.featureComplianceHubTitle',
            url: '/compliance-hub',
            Icon: ComplianceHubNavigationIcon,
            ownerOperatorRoot: (
                <React.Suspense fallback={<LoadingContent />}>
                    <LazyComplianceHubPage />
                </React.Suspense>
            ),
            tenantRoot: null,
        },
        permissions: [UserPermissions.ViewProperty],
    },
    disableFeature: [],
    checkIfEnabledViaSettings: () => isComplianceHubEnabled() ?? false,
};

export default complianceHubConfiguration;
